import { Promo } from '../enums/api';
import { Brand } from '../enums/common';
import { DocItemType } from './docs';
import { LocalizationType } from './localization';
import {
  AirReservationsType,
  CruiseReservationsType,
  HotelReservationsType,
} from './reservations';
import { BillingContactType, TravelerType } from './users';

export interface LoanOfferType {
  apr: number;
  docs?: {
    [key: string]: DocItemType;
  };
  down_payment: number;
  finance_charges: number;
  financed_amount: number;
  grand_total: number;
  loan_amount: number;
  localization?: LocalizationType;
  monthly_payment_amount: number;
  number_of_payments: number;
  offer_id: string;
  order_amount: number;
  origination_fee: number;
  pay_today: number;
  payment_due_day: number;
  promos?: Promo[];
  pure_down_payment: number;
  total_interest: number;
  total_payments: number;
  'offer?'?: boolean;
  offer?: boolean;
}

export interface OrderInfoType {
  air_reservations: AirReservationsType[];
  billing_contact: BillingContactType;
  cruise_reservations: CruiseReservationsType[];
  customer_id: string;
  hotel_reservations: HotelReservationsType[];
  localization: LocalizationType;
  merchant_data: { path: string };
  order_amount: number;
  travelers: TravelerType[];
  up_code: string;
  started_at: string;
  brand: Brand;
  campaigns: Object[] | [];
}

export enum OfferLabelType {
  ZERO_APR = 'ZERO_APR',
  LOWEST_MONTHLY_PAYMENT = 'LOWEST_MONTHLY_PAYMENT',
}
